import { ImageAnalyzer } from './ImageAnalyzer';

// Preserve original class name for backward compatibility
export class VisionAnalysisService {
  private analyzer: ImageAnalyzer;

  constructor() {
    this.analyzer = new ImageAnalyzer();
  }

  // Main analysis method
  public analyzeImage(imageDataUrl: string) {
    return this.analyzer.analyzeImage(imageDataUrl);
  }
}

// Export sub-modules for advanced use
export { ImageAnalyzer } from './ImageAnalyzer';
export { VisionPrompt } from './prompts/VisionPrompt';
export { ResponseParser } from './utils/ResponseParser';
